export const TOKEN_KEY = 'token';

export const storeToken = (token: string | null): void =>
  token
    ? localStorage.setItem(TOKEN_KEY, token)
    : localStorage.removeItem(TOKEN_KEY);

export const getToken = (): string | null => localStorage.getItem(TOKEN_KEY);
